import React from 'react'

const ParticularsOrganization = () => {
  return (
    <div className="container my-3">
    <div className="abouts">
      <h5>Particulars of Organization, Functions & Duties</h5>
    </div>

    <div className="about-box p-4 rounded shadow-lg " style={{textAlign:'justify'}}>
      <p>The Corporation was incorporated in 1974 under the Companies Act, 1956 with the objective of organizing production and distribution of certified seeds to the farmers of the State at reasonable rates. It has its Registered & Administrative Office at Panchkula. Besides it has also 6 Regional offices at Hisar, Sirsa, Umri, Yamunna Nagar, Tohana and Pataudi and one Marketing office at Bhiwani.</p>
    </div>
    </div>
  )
}

export default ParticularsOrganization
